<h1>Carbon War</h1>
<h2>What is Carbon War</h2>
Humans have conquered Earth. They have defied God, they have defied Nature. They have become the master.
But the war left too many casualties. We have forgotten them. It's time we look back, tend wounds and get ready again, because war is not over yet. A different kind of war awaits.
<div></div>

Maven lifecycle
Maven build phase
Maven plugin goal
